import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';

import { AddressUpgrade } from 'src/models/address-upgrade.model';

const ENDPOINT = `${environment.api_url}api/v1/customer/address-upgrades`;

@Injectable({
  providedIn: 'root'
})
export class AddressUpgradesService {

  private http = inject(HttpClient);

  async getAddressUpgrades(addressId?: number): Promise<AddressUpgrade[]> {
    let params = new HttpParams();
    if (addressId) {
      params = params.set('address_id', addressId);
    }
    return firstValueFrom(
      this.http.get<AddressUpgrade[]>(ENDPOINT, { params })
    );
  }

  async createAddressUpgrade(payload: Record<string, any>): Promise<AddressUpgrade> {
    return firstValueFrom(
      this.http.post<AddressUpgrade>(ENDPOINT, payload)
    );
  }

  async updateAddressUpgrade(id: number, payload: Record<string, any>): Promise<AddressUpgrade> {
    return firstValueFrom(
      this.http.put<AddressUpgrade>(`${ENDPOINT}/${id}`, payload)
    );
  }

  async deleteAddressUpgrade(id: number): Promise<void> {
    return firstValueFrom(
      this.http.delete<void>(`${ENDPOINT}/${id}`)
    );
  }
}
